import { UserTypes } from "../constants";

export type UserSearchFilters = {
  keyword: null | string;
  limit: number;
  offset: number;
  sort_by: string;
  user_type: UserTypes.CLIENT | UserTypes.STAFF;
  user_status?: string;
  user_assigned_to?: string;
};

export type UpdateRoleData = {
  id: string;
  user_type: Array<string>;
};

export enum UserStatuses {
  INPROGRESS_ONBOARDING = "INPROGRESS_ONBOARDING"
}